import { v4 as uuid } from 'uuid';

import { IWsSessionEvent } from './types';
import { GuardError } from '../../errors/GuardError';
import { setWsRegistration } from '../../slices/sessionSlice';
import { setSocketStatusFailed, setSocketStatusSucceed } from '../../slices/socketStatusSlice';
import { ERequestApiStatus, EWsClientEventType } from '../../types/appState';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { TThunkAction } from '../../types/redux/thunk';
import { ETelemetryEvents } from '../../types/telemetry';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { listenEventChannel } from '../socket';

/**
 * Регистрация сессии по WS
 */
export const registerWsSession =
  (startTime?: number): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { logger, telemetry, custom: { socket } }) => {
    if (!socket) {
      return;
    }

    const { clientEvents, eventChannel } = socket;

    const {
      session: { token },
    } = getState();

    if (!token) {
      const exception = new GuardError({
        domain: EExceptionDomain.Ws,
        message: 'Отсутствует токен сессии при попытке регистрации сессии по вебсокету',
      });

      logger.warning(exception);

      return;
    }

    // uid события сессии
    const sessionUid = uuid();

    const wsSession: IWsSessionEvent = {
      sessionToken: token.sessionToken,
      type: EWsClientEventType.Session,
      uid: sessionUid,
      userId: token.userId,
    };

    clientEvents.set(wsSession.uid, {
      status: ERequestApiStatus.Pending,
      type: EWsClientEventType.Session,
    });

    try {
      await eventChannel.updateSession(wsSession);

      dispatch(setWsRegistration(sessionUid));

      dispatch(setSocketStatusSucceed());
      dispatch(listenEventChannel());
      telemetry.increment(ETelemetryEvents.ChatWsSessionSuccess);
      if (startTime) {
        const timeInMs = new Date().getTime() - startTime;

        telemetry.timing(ETelemetryEvents.ChatWsTokenConnectTime, timeInMs);
      }
    } catch (err) {
      dispatch(setSocketStatusFailed());

      const errorToLog = getGenericLikeError({
        error: err,
        domain: EExceptionDomain.Ws,
        message: 'Не удалось зарегистрировать сессию по вебсокету',
      });

      logger.error(errorToLog, {
        sessionToken: token.sessionToken,
        userId: token.userId,
      });

      telemetry.increment(ETelemetryEvents.ChatWsSessionFail);

      clientEvents.set(wsSession.uid, {
        status: ERequestApiStatus.Failed,
        type: EWsClientEventType.Session,
      });
    }
  };
